import { queryOptions } from '@tanstack/react-query';
import {
  fetchAdvisorStatus,
  fetchAdvisorProfile,
  fetchAdvisorClients,
} from './api';

export const advisorQueryKeys = {
  all: () => ['advisor'] as const,
  status: () =>
    queryOptions({
      queryKey: [...advisorQueryKeys.all(), 'status'],
      queryFn: fetchAdvisorStatus,
    }),
  profile: () =>
    queryOptions({
      queryKey: [...advisorQueryKeys.all(), 'profile'],
      queryFn: fetchAdvisorProfile,
    }),
  clients: () =>
    queryOptions({
      queryKey: [...advisorQueryKeys.all(), 'clients'],
      queryFn: fetchAdvisorClients,
    }),
};
